import AOS from 'aos/dist/aos';

export default {
  init() {

    //AOS
    AOS.init({
      duration: 1200,
      offset: 250,
      animatedClassName: 'aos-animate',
      once: true,
    });

    // setTimeout(() => {AOS.refresh();}, 500);

    AOS.refresh()

    $( window ).resize(function() {
      AOS.refresh();
    });

    // SCROLLED
    $(window).on('scroll', function() {
      if ($(window).scrollTop() > 100) {
        $('body').addClass('scrolled');
      }
      else {
        $('body').removeClass('scrolled');
      }
    });

    // HAMBURGER
    $('.menu-menu-1-container ul li.menu-item-has-children').click(function() {
      if ($(this).hasClass('active')) {
        console.log('had al active');
        $(this).removeClass('active');
      } else {
        console.log('had geen active');
        $('.menu-menu-1-container ul li.menu-item-has-children').removeClass('active');
        $(this).addClass('active');
      }
    });

    // SCROLL
    $(document).on('click', 'a[href^="#"].scroll', function (event) {
        event.preventDefault();
        $('body,html').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 160,
        }, 500);
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js